<template>
    <div class="blog-vertical pt-2 pb-2">
        <a :href="route('blogs.show', blog.slug)" class="vertical-blog-card">
            <div class="blog-image">
                <img :src="blog.base_image.path" alt="blog image" class="w-100">
            </div>

            <div class="blog-info ml-3">
                <a :href="route('blogs.show', blog.slug)" class="blog-name multiple-line" style="max-height: 55px;">
                    <span class="blog-vertical-title" v-html="blog.name"></span>
                </a>

                <ul class="list-inline posted-info">
                    <li class="h6 mb-0 blog-created-at">
                        <i class="las la-calendar" aria-hidden="true"></i>
                        <small><span v-html="blog.created_at_format"></span></small>
                    </li>
                </ul>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        components: {},
        mixins: [],
        props: ['blog'],
        computed: {},
    };
</script>
